<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-md">
            <h5 class="card-title">Mitarbeiter</h5>
          </div>
          <div class="col-md text-right">
            <p-button class="mb-0 mt-0 mr-2" type="default" @click="addTrainer"><i class="bi bi-plus-circle" style="font-size: 12px;"></i> Neuer Mitarbeiter</p-button>
            <p-button class="mb-0 mt-0" type="default" @click="startPsSync" v-if="paperShiftSyncEnabled == 1">Papershift Sync</p-button>
          </div>
        </div>
      </div>
      <div class="card-body row">
        <div class="col-sm-12">
          <el-table
            :data="
              trainer.filter(
                (data) =>
                  !search ||
                  data.trainerName.toLowerCase().includes(search.toLowerCase())
              )
            "
            header-row-class-name="text-primary"
            empty-text="Es konnten keine Mitarbeiter gefunden werden."
            v-loading="loading"
            @row-click="editTrainer"
          >
            <el-table-column prop="trainerName" label="Name" min-width="130"> </el-table-column>
            <el-table-column prop="trainerTelefon" label="Telefon" min-width="130"></el-table-column>
            <el-table-column prop="trainerMail" label="E-Mail" min-width="200"></el-table-column>
            <el-table-column label="Unterweisungen" min-width="95">
              <template slot-scope="scope">
                <span v-if="scope.row.openInstructionCount > 0" class="text-danger">
                  <i class="bi bi-exclamation-triangle-fill"></i>
                  {{ scope.row.openInstructionCount }} offen
                </span>
                <span v-else class="text-success">
                  <i class="bi bi-check-circle"></i>
                  keine offen
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="trainerErsteHilefeKursDatum" label="Erste-Hilfe-Kurs" min-width="110">
              <template slot-scope="scope">
                <span v-if="scope.row.trainerErsteHilefeKursDatum != '-'" :style="scope.row.trainerErsteHilefeKursExpired ? 'color: red; font-weight: bold;' : ''">
                  {{ scope.row.trainerErsteHilefeKursDatum }}
                  <i
                    class="bi bi-exclamation-triangle-fill text-danger ml-1"
                    v-if="scope.row.trainerErsteHilefeKursExpired"
                    title="Der Erste-Hilfe-Kurs des Mitarbeiters ist abgelaufen."
                  ></i>
                </span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column
              class-name="action-buttons td-actions"
              align="right"
              label=""
            >
              <template slot="header" slot-scope="scope"> <!-- eslint-disable-line vue/no-unused-vars -->
                <el-input
                  v-model="search"
                  size="mini"
                  placeholder="Mitarbeiter suchen..."
                ><i slot="prefix" class="bi bi-search"></i></el-input>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { db, fc } from "../../../../firebaseDb";
import { Table, TableColumn, Tooltip, Input, Loading, Select, Option, MessageBox } from "element-ui";
import moment from "moment-timezone";
import router from "../../../../main";
import store from "../../../../store";
import { httpsCallable } from "firebase/functions";
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Tooltip);
//Vue.use(Loading);

export default {
  components: {
    [Input.name]: Input,
    [Select.name]: Select,
    [Option.name]: Option,
    MessageBox
  },

  data() {
    return {
      trainer: [],
      lastSync: null,
      lastSyncTimestamp: null,
      search: "",
      loading: true,
      location: store.getters.userlocation,
      role: store.getters.userrole,
      paperShiftSyncEnabled: process.env.VUE_APP_ENABLE_PAPERSHIFT_SYNC,
    };
  },
  created() {
    this.loadData();
    store.watch(
      (state) => state.userlocation,
      () => {
        this.location = store.getters.userlocation;
        this.loadData();
      }
    );
  },
  methods: {
    loadData() {
      // get last Papershift sync time
      const lastSyncRef = db.collection("papershiftSyncStatus");
      var docname = "trainer"
      lastSyncRef
        .doc(docname)
        .get()
        .then((doc) => {
          this.lastSync = moment(new Date(doc.data().lastSync.seconds * 1000))
            .format("DD.MM.YY HH:mm")
            .toString();
          this.lastSyncTimestamp = doc.data().lastSync.seconds * 1000
        });

      // get list of trainers
      const trainerRef = db.collection("trainer");
      trainerRef.where('locationID', 'array-contains', this.location).orderBy("Name").onSnapshot((snapshotChange) => {
        const list = [];
        const countPromises = [];
        snapshotChange.forEach((doc) => {
          let trainerErsteHilfeKursExpired = false;
          let trainerErsteHilfeKursDatum = doc.data().ErsteHilfeKursDatum ? moment(doc.data().ErsteHilfeKursDatum.seconds * 1000).format("MM/YYYY") : "-";
          if(trainerErsteHilfeKursDatum != '-') {
            const ehkDate = moment(doc.data().ErsteHilfeKursDatum.seconds * 1000);
            const ehkDatePlusXYears = ehkDate.add(process.env.VUE_APP_ERSTE_HILFE_KURSE_INTERVALL_YEARS, 'years');
            if(ehkDatePlusXYears.isBefore(moment())) {
              trainerErsteHilfeKursExpired = true;
            }
          }
          if(trainerErsteHilfeKursDatum == "01/1970") {
            trainerErsteHilfeKursDatum = '-'
            trainerErsteHilfeKursExpired = false;
          }
          const row = {
            key: doc.id,
            trainerName: doc.data().Name,
            trainerID: doc.data().ID,
            trainerMail: doc.data().Mail,
            trainerTelefon: doc.data().Telefon,
            trainerErsteHilefeKursDatum: doc.data().ErsteHilfeKursDatum ? trainerErsteHilfeKursDatum : '-',
            trainerErsteHilefeKursExpired: trainerErsteHilfeKursExpired,
            openInstructionCount: 0,
          };
          list.push(row);
          const p = db
            .collection('trainer')
            .doc(row.key)
            .collection('unterweisungen')
            .where('status', '==', 'offen')
            .get()
            .then((q) => { row.openInstructionCount = q.size; })
            .catch(() => { row.openInstructionCount = 0; });
          countPromises.push(p);
        });
        Promise.all(countPromises).then(() => {
          this.trainer = list;
          this.loading = false;
        });
      });
    },
    editTrainer(row, column) {
      router.push({ name: "editTrainer", params: { trainerId: row.key } });
    },
    addTrainer() {
      router.push({ name: "newTrainer" });
    },
    startPsSync() {
      if(new Date().getTime() - this.lastSyncTimestamp > 600000) { // greater 10mins
        const loading = this.$loading({
          lock: true,
          text: 'Papershift Sync läuft...',
          spinner: 'el-icon-loading'
        });
        console.log("Start PS trainer sync")
        var getTrainer = httpsCallable(fc, "papershift-getPSTrainer");
        getTrainer([]).then((result) => {
          console.log('PS Trainer Sync done')
          this.loadData()
          loading.close()
        });
      } else {
        MessageBox.alert(
            "Mitarbeiter können erst 10 Minuten nach der letzten Synchronisation erneut aus Papershift abgerufen werden. Die letzte Synchronisation war am " + this.lastSync + " Uhr.",
            {
              confirmButtonText: "OK",
              type: "warning",
              callback: (action) => {},
            }
          );
      }
    },
  },
};
</script>
<style>
</style>
